<template lang="pug">
    div#gallery-view
        mainHeader
        div.has-text-centered
            strong.title Gallery
        hr
        div.columns.is-centered
            div.column
            div.container
                    VueGallery(:images="images", :index="index", @close="index = null")

                    div.image(v-for="image, imageIndex in images", @click="index = imageIndex", :style="{ backgroundImage: 'url(' + image + ')', width: '250px', height: '150px' }")
        hr.unfloat
        Footer
</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import Footer from "@/components/Footer.vue";
import VueGallery from 'vue-gallery';

export default {
    name: 'gallery',
    components: {
        MainHeader,
        VueGallery,
        Footer
    },
    data: function () {
        return {
            // baseUrl: process.env.BASE_URL,
            images: [
                "/img/gallery/10.jpg",
                "/img/gallery/12.jpg",
                "/img/gallery/13.jpg",
                "/img/gallery/2014_06_30_21_15_25.jpg",
                "/img/gallery/2014_07_25_00_49_17.jpg",
                "/img/gallery/26.jpg",
                "/img/gallery/DSC01461.jpg",
                "/img/gallery/DSC01668.jpg",
                "/img/gallery/DSC01669.jpg",
                "/img/gallery/DSC01670.jpg",
                "/img/gallery/DSC01672.jpg",
                "/img/gallery/DSC_0009.jpg",
                "/img/gallery/DSC_0013_2.jpg",
                "/img/gallery/DSC_0044.jpg",
                "/img/gallery/DSC_0056.jpg",
                "/img/gallery/DSC_0182.jpg",
                "/img/gallery/e8.jpg",
                "/img/gallery/e9.jpg",
                "/img/gallery/frank_wang_1061133_unsplash.jpg",
                "/img/gallery/Gaea.jpg",
                "/img/gallery/IMG_20140624_181734547.jpg",
                "/img/gallery/IMG_20180330_160411.jpg",
                "/img/gallery/SAM_0238.jpg",
                "/img/gallery/SAM_0270.jpg",
                "/img/gallery/SAM_0279.jpg",
                "/img/gallery/SAM_0290.jpg",
                "/img/gallery/SAM_0541.jpg",
                "/img/gallery/SAM_0555.jpg",
                "/img/gallery/SAM_0700.jpg",
                "/img/gallery/SAM_0738.jpg",
                "/img/gallery/SAM_0749.jpg",
                "/img/gallery/SAM_0752.jpg",
                "/img/gallery/SAM_0760.jpg",
                "/img/gallery/SAM_0800.jpg",
                "/img/gallery/SAM_0935fb.jpg",
                "/img/gallery/SAM_1008.jpg",
                "/img/gallery/SAM_1027.jpg",
                "/img/gallery/SAM_1109.jpg",
                "/img/gallery/SAM_1134.jpg",

            ],
            index: null,
        };
    }

}
</script>

<style scoped>
.image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
}

.unfloat {
    clear: both;
}

hr {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    border-bottom-width: 80%;
    margin-bottom: 2rem;
}
</style>

